module.exports = __webpack_public_path__ + "img/29_22.01465b1a.png";